import { VApp } from 'vuetify/lib/components/VApp';
import { VContent } from 'vuetify/lib/components/VContent';
import Resize from 'vuetify/lib/directives/resize';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VApp,{directives:[{def: Resize,name:"resize",rawName:"v-resize",value:(_vm.onResize),expression:"onResize"}],staticStyle:{"font-family":"'微软雅黑'"}},[(_vm.$vuetify.breakpoint.name != 'xs' ||
    _vm.$route.path == '/Register_mobile' ||
    _vm.$route.path == '/MobilePublicity' ||
    _vm.$route.path == '/PrivacyPolicy_mobile' ||
    _vm.$route.path == '/ServiceAgreement_mobile'
    )?_c(VContent,[(!(_vm.hideTopNaviUrls.indexOf(_vm.$route.path) > -1) &&
      !/\/Archive/.test(_vm.$route.path) && _vm.$route.path != '/homeWork' && _vm.$route.path != '/coursePlay'
      )?_c('home-navi',{key:_vm.$route.path,staticStyle:{"z-index":"999"}}):_vm._e(),(_vm.isRouterAlive)?_c('router-view'):_vm._e(),(
      _vm.$route.path == '/' ||
      _vm.$route.path == '/courseDetail' ||
      _vm.$route.path == '/directSeeding'
      )?_c('home-footer'):_vm._e(),(
      _vm.$route.path == '/signInContent' ||
      _vm.$route.path == '/signInResult' ||
      _vm.$route.path == '/globalCourse' ||
      _vm.$route.path == '/universityUserCenter' ||
      _vm.$route.path == '/courseShow' ||
      _vm.$route.path == '/homeWork' ||
      _vm.$route.path == '/coursePlay' ||
      _vm.$route.path == '/graduationCertificate' ||
      _vm.$route.path == '/excellentRecognition'
      )?_c('HomeFooterWhite'):_vm._e()],1):_vm._e(),(_vm.$vuetify.breakpoint.name == 'xs' &&
    _vm.$route.path != '/Register_mobile' &&
    _vm.$route.path != '/PrivacyPolicy_mobile' &&
    _vm.$route.path != '/ServiceAgreement_mobile' &&
    _vm.$route.path != '/MobilePublicity'
    )?_c('NoMobile'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }